import { render } from "./CompletePage.vue?vue&type=template&id=6a65096d"
import script from "./CompletePage.vue?vue&type=script&lang=ts"
export * from "./CompletePage.vue?vue&type=script&lang=ts"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "6a65096d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6a65096d', script)) {
    api.reload('6a65096d', script)
  }
  
  module.hot.accept("./CompletePage.vue?vue&type=template&id=6a65096d", () => {
    api.rerender('6a65096d', render)
  })

}

script.__file = "src/views/registerTeam/CompletePage.vue"

export default script